/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import { KTSVG } from '../../../_metronic/helpers';
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { useAuth } from '../../modules/auth';
import useSize from '../../hooks/useSize';
import { TableOrderOfService } from './components/ScreenServices/components/TableOrderOfService';
import { Link } from 'react-router-dom';
//import { MyPortal } from './components/my-portal'

const requestServicesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Início',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ServicesOSPage: FC = () => {
    const [refreshPage, setRefreshPage] = useState<boolean>(false);
    const user = useAuth()
    const {height, width} = useSize();
    const isMobile = width < 992;
    const showMobileTitle = isMobile && user.currentUser?.role?.slug === 'CLIENTE';
    const [pages, setPages] = useState<number>(0);


  return (
    <div 
      className={`column g-5 g-xl-8 card ${isMobile ? 'p-4' : 'p-7'}`}
      style={
        isMobile
          // No celular a lista rola com a página: altura livre e folga para o menu inferior fixo.
          ? { height: 'auto', paddingBottom: '1rem', marginBottom: '6.5rem' }
          : {
              height: height <= 750 ? '68vh'
              : height <= 850 ? '70vh'
              : height <= 930 ? '70vh'
              : '72vh',
              paddingBottom: '1rem'
            }
      }>
       <div style={{height: '100%'}}>
          <div style={{display: 'flex', justifyContent: showMobileTitle ? 'space-between' : 'end', alignItems: 'center', gap: '0.5rem'}}>
            {showMobileTitle && (
              <span className='d-inline-flex align-items-center fw-bolder fs-6 text-primary'>
                Serviços
                <i className='bi bi-chevron-right fs-8 text-gray-500 mx-2' aria-hidden />
                <span className='text-gray-800'>O.S</span>
              </span>
            )}
            <Link
              to='/solicitacoes'
              className={`btn btn-sm btn-light-primary nav-link text-muted fw-bold ${isMobile ? 'py-2 px-3 fs-8' : ''}`}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className={isMobile ? 'svg-icon-5' : 'svg-icon-3'} />
              Solicitação de Serviço
            </Link>
          </div>

          <div style={{height: isMobile ? 'auto' : '100%', marginTop: isMobile ? '0.5rem' : undefined}}>
              <TableOrderOfService 
                className={'w-100'}
                refreshPage={refreshPage}
                setRefreshPage={setRefreshPage}
              />
          </div>
       </div>
    </div>
  )
}

const ServicesOSWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={requestServicesBreadcrumbs}>Meus serviços</PageTitle>
      <ServicesOSPage />
    </>
  )
}

export {ServicesOSWrapper}


